<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<div class="title-part"><a href="#/e9781250024572_toc01#toctitle2" id="title2"><span><strong class="b">PART ONE</strong></span></a></div>
<div class="illustype_image"><div class="image"><img alt="e9781250024572_i0002.jpg" src="e9781250024572_i0002.jpg"/></div></div>
<div class="verse"><span><em class="i">“It is remarkable,” he said. “A man cannot make general<br/> observations to any extent, on any subject, without betraying<br/> himself, without introducing his entire individuality,<br/> and presenting, as in an allegory, the fundamental<br/> theme and problem of his own existence. This,<br/> Engineer, is what you have just done.”</em></span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="source"><span>—SETTEMBRINI TO HANS CASTORP<br/> THOMAS MANN, <em class="i">THE MAGIC MOUNTAIN</em></span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781250024572_p01.vue?5ef9adb0